import { useNavigate } from 'react-router';

import { editProjectTour } from '@/domain/project-tour/actions/edit-project-tour.action';
import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import {
  selectCurrentProjectTour,
  selectIsEditingProjectTour,
} from '@/domain/project-tour/project-tour.selectors';
import { PageTitle } from '@/ui/components/PageTitle';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { EditProjectFormButtons } from '@/ui/pages/app/components/edit-project/EditProjectFormButtons';
import { EditProjectPaper } from '@/ui/pages/app/components/edit-project/EditProjectPaper';

import { ProjectTourForm } from '../components/ProjectTourForm';

export function EditProjectTour() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectTour);

  const isEditingProject = useAppSelector(selectIsEditingProjectTour);

  const handleEditProject = async (data: ProjectTour) => {
    try {
      const params = { project: data };
      await dispatch(editProjectTour(params)).unwrap();
      navigate(`/app/projects/tour/${project?.id}`);
    } catch (error) {
      console.error(error);
    }
  };

  const onClickBack = () => {
    navigate(`/app/projects/tour/${project?.id}`);
  };

  if (!project) {
    return null;
  }

  return (
    <>
      <PageTitle
        title={translate('ProjectsTour.edit-tour-page-title')}
        backButtonText={project?.name}
        onClickBack={onClickBack}
      />
      <EditProjectPaper>
        <ProjectTourForm
          project={project}
          onSubmit={handleEditProject}
          buttons={
            <EditProjectFormButtons isEditingProject={isEditingProject} />
          }
        />
      </EditProjectPaper>
    </>
  );
}
